
<nav class="navbar navbar-top fixed-top navbar-expand bg-primary justify-content-between">
    <ul class="navbar-nav">
        <li class="nav-item">
            <a class="navbar-brand" [routerLink]="['/']" >
                <img src="/assets/images/logo-bianco.png" alt="logo-bianco" />
            </a>
        </li>
        <li class="nav-item">
            <div class="vertical-divider bg-white"></div>
        </li>
        <li class="nav-item">
            <a class="nav-link nav-link--icon" [routerLink]="['/']" title="I miei progetti">
                <svg-icon name="my-projects" svgClass="nav-link--svg-size"></svg-icon>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link nav-link--icon" [routerLink]="['/all-projects']" title="Tutti i progetti">
                <svg-icon name="team-projects" svgClass="nav-link--svg-size"></svg-icon>
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link nav-link--icon" href="javascript:;" (click)="onAddProjectClick()" title="Nuovo progetto">
                <svg-icon name="circle-plus" svgClass="nav-link--svg-size"></svg-icon>
            </a>
        </li>
    </ul>
    <ul class="navbar-nav navbar-nav--user">
        <li class="nav-item" [hidden]="true">
            <a class="nav-link nav-link--icon" [routerLink]="['/']">
                <svg-icon name="user" svgClass="nav-link--svg-size"></svg-icon>
            </a>
        </li>
        <li class="nav-item">
            <app-language-selector [showLabel]="false" mode="dropdown" menuAlign="end"></app-language-selector>
        </li>
        <li class="nav-item">
            <a class="nav-link nav-link--icon" href="javascript:;" (click)="onLogoutClick()" title="Logout">
                <svg-icon name="logout" svgClass="nav-link--svg-size"></svg-icon>
            </a>
        </li>
    </ul>
</nav>
